import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  BriefcaseIcon,
  BuildingOffice2Icon,
  MapPinIcon,
  UserGroupIcon,
  ClipboardDocumentCheckIcon,
  ClipboardDocumentListIcon,
  UsersIcon,
} from '@heroicons/react/24/outline';
import { useAuth } from '../contexts/AuthContext';

const navItems = [
  { to: '/dashboard', label: 'Dashboard', icon: HomeIcon },
  { to: '/jobs', label: 'Jobs', icon: BriefcaseIcon },
  { to: '/registrations', label: 'Registrations', icon: ClipboardDocumentCheckIcon },
  { to: '/vendor-applications', label: 'Vendor applications', icon: ClipboardDocumentListIcon },
  { to: '/accounts', label: 'Accounts', icon: BuildingOffice2Icon },
  { to: '/locations', label: 'Locations', icon: MapPinIcon },
  { to: '/vendors', label: 'Vendors', icon: UserGroupIcon },
  { to: '/users', label: 'Admin users', icon: UsersIcon },
];

const linkClass = (active) =>
  `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
    active
      ? 'bg-teal-700 text-white'
      : 'text-teal-100 hover:bg-teal-800 hover:text-white'
  }`;

const Sidebar = () => {
  const { logout, user } = useAuth();
  const location = useLocation();

  const isActive = (to) => {
    if (to === '/dashboard') return location.pathname === '/dashboard';
    return location.pathname === to || location.pathname.startsWith(`${to}/`);
  };

  return (
    <aside className="w-56 shrink-0 bg-teal-900 text-white min-h-screen flex flex-col">
      <div className="px-4 py-5 border-b border-teal-800">
        <p className="font-semibold text-lg leading-tight">Cleaning Admin</p>
        {user?.email && (
          <p className="text-teal-200 text-xs mt-1 truncate">{user.email}</p>
        )}
      </div>
      <nav className="flex-1 px-2 py-4 space-y-1">
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink key={to} to={to} className={linkClass(isActive(to))}>
            <Icon className="w-5 h-5 shrink-0" />
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="p-4 border-t border-teal-800">
        <button
          type="button"
          onClick={logout}
          className="w-full text-left text-sm text-teal-200 hover:text-white px-3 py-2 rounded-lg hover:bg-teal-800"
        >
          Log out
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
